import { default as FontFaceObserver } from 'fontfaceobserver';

const LoadFonts = (fontFamilies) => {
  let fs = []

  fontFamilies.forEach((font) => {
    var f = new FontFaceObserver(font);
    fs.push(f.load())
  });

  return Promise.all(fs);
}

export default LoadFonts;
